import React from "react";
import "./TeacherGrid.sass"
import IconItemGrid, {IconItemGridType} from "../common/grid/IconItemGrid";
import {blue} from "../../common/colors";
import {ReactComponent as Teacher} from "../../images/release/teacher.svg";
import {ReactComponent as Schedule} from "../../images/release/schedule.svg";
import {ReactComponent as Balance} from "../../images/release/balance.svg";
import {ReactComponent as Training} from "../../images/release/training.svg"
import SimpleGrid from "../../_containers/grid/SimpleGrid";
import {useLocation} from "react-router";
import {useSelector} from "react-redux";
import InfoMessage from "../common/grid/InfoMessage";
import {HOME, PAY_PAGE, SCHEDULE_TEACHER_PAGE, TRAINERS_PAGE} from "../../common/links";

export default function TeacherGrid() {

    const {data: info} = useSelector(state => state.notification.getInfo);

    const location = useLocation();

    return (
        <div className="teacher-grid-wrapper">
            <SimpleGrid>
                <IconItemGrid Icon={Teacher}
                              link={HOME}
                              backgroundColor={blue}
                              title="Пользователь"
                              selected={location.pathname === HOME}
                              type={IconItemGridType.COMMON}/>
                <IconItemGrid Icon={Schedule}
                              link={SCHEDULE_TEACHER_PAGE}
                              backgroundColor={blue}
                              title="Расписание и группы"
                              selected={location.pathname === SCHEDULE_TEACHER_PAGE}
                              type={IconItemGridType.COMMON}/>
                {/*<IconItemGrid Icon={Requests}*/}
                {/*              link={REQUEST_ADMIN_PAGE}*/}
                {/*              message={info && !!info.requestCount ? <InfoMessage type="info" value={info.requestCount}/> : undefined}*/}
                {/*              backgroundColor={blue}*/}
                {/*              title="Заявки"*/}
                {/*              selected={location.pathname === REQUEST_ADMIN_PAGE*/}
                {/*              type={IconItemGridType.COMMON}/>*/}
                <IconItemGrid Icon={Training}
                              link={TRAINERS_PAGE}
                              selected={location.pathname === TRAINERS_PAGE}
                              backgroundColor={blue}
                              title="Тренажёры"
                              type={IconItemGridType.COMMON}/>
                <IconItemGrid Icon={Balance}
                              message={info && !!info.paymentCount ? <InfoMessage type="info" value={info.paymentCount}/> : undefined}
                              link={PAY_PAGE}
                              backgroundColor={blue}
                              title="Оплата"
                              selected={location.pathname === PAY_PAGE}
                              type={IconItemGridType.COMMON}/>
            </SimpleGrid>
        </div>
    )
}